<template>
  <div
    v-if="changeLogFeatureFlag"
  >
    <popover
      v-if="showChangeLog"
      v-model="showChangeLog"
      v-click-outside="{binding: togglePopover, focus: '.popover'}"
      :class="'breakdown-legend__popover'"
      :target="`#popover-${objectId}`"
      :placement="'left'"
      trigger="manual"
    >
      <template slot="popover">
        <h2 class="m-b-10 in-app-header">
          {{ $t('TITLE_ACTIVITY_FEED') }} {{ objectType }}:
          <strong v-text="objectName" />
        </h2>
        <a
          class="close in-app-popover__btn-close"
          @click="togglePopover"
        >
          <i class="typcn typcn-delete" />
        </a>
        <ChangeLog
          v-if="showChangeLog"
          :custom-class="'changelogs--md'"
          :object-id="objectId"
          :show-non-primary-actions="showNonPrimaryActions"
        />
      </template>
    </popover>
    <div class="action-icon">
      <a
        :id="`popover-${objectId}`"
        :disabled="isDisabled"
        class="m-t-4 btn btn-list-function "
        @click="togglePopover"
      >
        <i
          v-tooltip.right.hover="$t('VIEW_ACTIVITY_TEXT')"
          class="fa fa-history"
          aria-hidden="true"
        />
        <span
          v-t="'VIEW_ACTIVITY_TEXT'"
          class="hint-text-mobile"
        />
      </a>
    </div>
  </div>
</template>

<script>
import messages from './locales';
import { mapGetters } from 'vuex';
import ChangeLog from './ChangeLog';

export default {
  name: 'ChangeLogObjectButtonAction',
  components: {
    ChangeLog
  },
  props:{
    objectType: {
      type: String,
      default: ''
    },
    objectName: {
      type: String,
      default: ''
    },
    objectId: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    showNonPrimaryActions: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showChangeLog: false
    };
  },
  computed: {
    ...mapGetters([
      'changeLogFeatureFlag'
    ])
  },
  methods: {
    togglePopover() {
      if (!this.isDisabled) {
        this.showChangeLog = !this.showChangeLog;
      }
    }
  },
  i18n: {
    messages,
    locale: 'en',
  }
};
</script>
